<body>
  @if (this.authService.loggedInSubject|async) {
    <router-outlet></router-outlet>
  }
</body>